import imageObject from './types/imageObject';
import brandType from './types/brand';
import occupation from './types/occupation';
import { organizationType } from './organizationType';

/**
 * Person type
 * DOC: https://schema.org/Person
 */

export const personType = ({
  id,
  url,
  brand,
  familyName,
  givenName,
  additionalName,
  hasOccupation,
  honorificSuffix,
  jobTitle,
  knowsAbout,
  publishingPrinciples,
  image,
  worksFor,
  email,
  disambiguatingDescription,
  sameAs
}) => {
  if (!id || typeof id === 'undefined') {
    throw new Error('id argument is required');
  }
  const result = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    '@id': id,
    url: url,
    ...(email && {
      email
    }),
    ...(familyName && {
      familyName
    }),
    ...(additionalName && {
      additionalName
    }),
    ...(givenName && {
      givenName
    }),
    ...(hasOccupation && {
      hasOccupation: occupation(hasOccupation)
    }),
    ...(honorificSuffix && {
      honorificSuffix
    }),
    ...(brand && {
      brand: brandType(brand)
    }),
    ...(worksFor && {
      worksFor: JSON.parse(organizationType(worksFor))
    }),
    ...((knowsAbout === null || knowsAbout === void 0 ? void 0 : knowsAbout.length) > 0 && {
      knowsAbout
    }),
    ...(jobTitle && {
      jobTitle
    }),
    ...(publishingPrinciples && {
      publishingPrinciples
    }),
    ...(disambiguatingDescription && {
      disambiguatingDescription
    }),
    ...(image && {
      image: imageObject(image)
    }),
    ...((sameAs === null || sameAs === void 0 ? void 0 : sameAs.length) > 0 && {
      sameAs
    })
  };
  return JSON.stringify(result);
};